var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdBannerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02.Icons / Basic / Solid / Bath Tub") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-copy-11",
    transform: "translate(-54.000000, -25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.Icons-/-Basic-/-Solid-/-Bath-Tub",
    transform: "translate(54.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,0.833333333 C10.23716,0.833333333 10.4292933,1.02561333 10.4292933,1.26262667 L10.4292933,1.26262667 L10.4292933,1.56754667 L18.7281333,1.56754667 C18.9651467,1.56754667 19.1574267,1.75982667 19.1574267,1.99684 C19.1574267,2.23370667 18.9651467,2.42598667 18.7281333,2.42598667 L18.7281333,2.42598667 L18.7281333,3.28530667 C18.7281333,3.52232 18.52808,3.71372 18.29092,3.71372 L18.29092,3.71372 L18.2989867,3.71372 L18.2989867,14.5739467 C18.2989867,14.81096 18.00228,15.0174667 17.76512,15.0174667 L17.76512,15.0174667 L10.4292933,15.0174667 L10.4292933,18.3082267 L14.15008,18.3082267 C14.38724,18.3082267 14.5793733,18.5006533 14.5793733,18.73752 C14.5793733,18.9745333 14.38724,19.1668133 14.15008,19.1668133 L14.15008,19.1668133 L5.85124,19.1668133 C5.61408,19.1668133 5.42194667,18.9745333 5.42194667,18.73752 C5.42194667,18.5006533 5.61408,18.3082267 5.85124,18.3082267 L5.85124,18.3082267 L9.57070667,18.3082267 L9.57070667,15.01732 L2.23590667,15.01732 C1.99889333,15.01732 1.84430667,14.8108133 1.84430667,14.5738 L1.84430667,14.5738 L1.84430667,3.71372 L1.71010667,3.71372 C1.47309333,3.71372 1.27201333,3.52232 1.27201333,3.28530667 L1.27201333,3.28530667 L1.27201333,2.42598667 C1.03485333,2.42598667 0.84272,2.23370667 0.84272,1.99684 C0.84272,1.75982667 1.03485333,1.56754667 1.27201333,1.56754667 L1.27201333,1.56754667 L9.57070667,1.56754667 L9.57070667,1.26262667 C9.57070667,1.02561333 9.76284,0.833333333 10,0.833333333 Z M2.70274667,3.70052 L2.70274667,9.24892 L4.2074,7.76612 L5.42136,8.95822667 L5.42136,9.0078 L5.36269333,9.0078 L5.44834667,9.08421333 L8.16828,6.34624 L12.4004933,10.5654 L15.2340933,7.75790667 L17.4402533,9.912 L17.4402533,3.70653333 L2.70274667,3.70052 Z M12.1501333,5.138 C12.7057244,5.138 13.15612,5.58839557 13.15612,6.14398667 C13.15612,6.69957776 12.7057244,7.14997333 12.1501333,7.14997333 C11.5945422,7.14997333 11.1441467,6.69957776 11.1441467,6.14398667 C11.1441467,5.58839557 11.5945422,5.138 12.1501333,5.138 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdBannerIcon);
export default __webpack_public_path__ + "static/media/AdBannerIcon.b058cbb4f119df673fcaff1bd9bb328c.svg";
export { ForwardRef as ReactComponent };